// ==================================== COMPONENTS =========================================
// THIRD PARTY/ CORE COMPONENTS
import React from 'react';
import { Row, Col, Form, Input, Select } from 'antd';
import propTypes from 'prop-types';

// USER'S COMPONENTS
import { Button } from '../../../components/buttons/buttons';
import { Modal } from '../../../components/modals/antd-modals';
import { BasicFormWrapper } from '../../styled';

const EditServicingHistory = ({ visible, onCancel, handleEdit, history }) => {
  // To handle the edit history
  const handleSubmit = (datas) => {
    Object.keys(datas).map(key => {
      if (!datas[key]) delete datas[key];
    })

    handleEdit(history._id, datas);
    onCancel();
  }

  // Formatting the date for input type date in html
  let date = '';
  if (history.date) {
    date = new Date(history.date).toLocaleDateString().split('/');
    date = `${date[2]}`;
    if (date[0] < 10) date = `${date}-0${date[0]}`;
    else date = `${date}-${date[0]}`;
    if (date[1] < 10) date = `${date}-0${date[1]}`;
    else date = `${date}-${date[1]}`;
  }

  return Object.keys(history).length > 0 ? (
    <Modal
      type={'primary'}
      title="Update Servicing History"
      visible={visible}
      footer={null}
      onCancel={onCancel}
    >
      <div className="body-type-modal">
        <BasicFormWrapper>
          <Form
            name="basic"
            initialValues={{ ...history, date }}
            onFinish={handleSubmit}
            autoComplete="off"
          >
            {/* servicing center */}
            <div className="add-product-block">
              <Row>
                <Col xs={24}>
                  <Form.Item
                    name="serviceCenter"
                    label="Service Center"
                    rules={[
                      {
                        required: true,
                        message: 'Please input name of service center!',
                      },
                    ]}
                  >
                    <Input placeholder="Auto24 servicing center" />
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <br />
            {/* date and driven km */}
            <div className="add-product-block">
              <Row>
                <Col xs={11}>
                  <Form.Item name="drivenKM" label="Driven KM"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter the total driven KM!',
                      },
                    ]}>
                    <Input type={'number'} placeholder={123304} />
                  </Form.Item>
                </Col>
                <Col xs={1}></Col>
                <Col xs={11}>
                  <Form.Item name="date" label="Service Date"
                    rules={[
                      {
                        required: true,
                        message: 'Please enter the date of service',
                      },
                    ]}>
                    <Input type={'date'} />
                  </Form.Item>
                </Col>
              </Row>
            </div>
            <br />
            <br />
            <Form.Item
              wrapperCol={{
                offset: 10,
                span: 16,
              }}
            >
              <Button style={{ backgroundColor: '#155BDC', color: '#fff' }} htmlType="submit">
                Update Service History
              </Button>
            </Form.Item>
          </Form>
        </BasicFormWrapper>
      </div>
    </Modal>
  ) : null;
};

EditServicingHistory.propTypes = {
  visible: propTypes.bool.isRequired,
  onCancel: propTypes.func.isRequired,
};

export default EditServicingHistory;